import {
    OPERATOR_MODEL_START,
    OPERATOR_MODEL_SUCCESS,
    OPERATOR_MODEL_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    data: [],
  };
  
  export default function ModelReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case OPERATOR_MODEL_START:
        return {
          ...state,
          loading: true,
        };
      case OPERATOR_MODEL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case OPERATOR_MODEL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  